import "./ClosedRequest.css";
import React, { useState, useEffect } from "react";
import { db } from "../../index";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { groupBy, mapValues } from 'lodash';
import { useUserRole } from "../../components/Context/useUserRole";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const LoadingIndicator = () => (
    <div className="loading-indicator">
        <p>Загрузка...</p>
    </div>
  );
  
  const EmptyRequestsMessage = () => (
    <div className="empty-requests-message">
        <p>Данные не найдены <img src="./img/document-error.svg" alt="NotFoundData" /></p>
    </div>
  );

  const ClosedRequestRow = ({ request, handleCloseForm }) => (
    <div key={request.id} onClick={() => handleCloseForm(request.id)} className="items-table__opened items-table">
      <div className="width_item">
        <h2>{request.nameObject}</h2>
        <p>{request.address}</p>
      </div>
      <div className="width_item">
        <p>{request.description}</p>
      </div>
      <div>
        <p>{request.date}</p>
      </div>
      <div className="items-table__opened-cell-last">
        <p>{request.createdDate}</p>
      </div>
      <div className="img-priority">
        <img src={request.selectedImage} alt="priority" />
      </div>
    </div>
  );
  
  export function ClosedRequest() {
    const [closedRequests, setClosedRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [engineersStats, setEngineersStats] = useState([]);
    const [dispatchersStats, setDispatchersStats] = useState([]);
    const role = useUserRole()
    const navigate = useNavigate();
  
    useEffect(() => {
      const requestsRef = ref(db, "request");
      onValue(requestsRef, (snapshot) => {
        const requests = [];
        snapshot.forEach((childSnapshot) => {
          requests.push({ id: childSnapshot.key,...childSnapshot.val() });
        });
    
        const sortedRequests = requests
          .filter((request) => request.idRequest)
          .filter((request) => {
            if (selectedMonth === null && selectedYear === null) {
              return true;
            }
            const requestDate = new Date(request.date);
            const requestMonth = requestDate.getMonth() + 1;
            const requestYear = requestDate.getFullYear();
            return (selectedMonth === null || requestMonth === selectedMonth) &&
              (selectedYear === null || requestYear === selectedYear);
          })
          .sort((a, b) => new Date(a.date) - new Date(b.date))
          .sort((a, b) => {
            if (a.selectedImage === "./img/high-priority.svg" && b.selectedImage!== "./img/high-priority.svg") {
              return -1;
            } else if (a.selectedImage!== "./img/high-priority.svg" && b.selectedImage === "./img/high-priority.svg") {
              return 1;
            } else {
              return 0;
            }
          });
    
        setClosedRequests(sortedRequests);
    
        const engineersStats = getEngineersStats(sortedRequests);
        setEngineersStats(engineersStats);
    
        const dispatchersStats = getDispatchersStats(sortedRequests);
        setDispatchersStats(dispatchersStats);
    
        getDispatchersNames(sortedRequests);
    
        setLoading(false);
      });
    }, [selectedMonth, selectedYear]);
  
    const handleCloseForm = (closeRequestID) => {
      navigate(`/closedRequest/${closeRequestID}`);
    };
    
    const handleMonthChange = (e) => {
      const selectedMonth = parseInt(e.target.value);
      setSelectedMonth(selectedMonth || null);
    };
  
    const handleYearChange = (e) => {
      const selectedYear = parseInt(e.target.value);
      setSelectedYear(selectedYear || null);
    };

    const [showStatsModal, setShowStatsModal] = useState(false);
    const handleShowStatsModal = () => {
      if (role === 'Директор') {
        setShowStatsModal(true);
      }
    };

    const getEngineersStats = (requests) => {
      const groupedByEngineer = groupBy(requests, 'engineer');
      const engineersStats = mapValues(groupedByEngineer, (requests) => {
        return {
          engineer: requests[0].engineer,
          count: requests.length,
        };
      });
      return Object.values(engineersStats);
    };

    const currentDate = new Date();
    const fileName = `Отчет_${currentDate.toLocaleDateString()}.pdf`;
    
    const handleDownloadPdf = () => {
      if (closedRequests.length === 0) {
        alert('Данные не найдены. Нельзя скачать PDF.');
        return;
      }
      const months = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ];
    
      const docDefinition = {
        content: [
          {
            text: 'Статистика',
            fontSize: 24,
            bold: true,
            alignment: 'center'
          },
          {
            text: `Выбранный месяц: ${selectedMonth === null? 'Все месяца' : months[selectedMonth - 1]}`,
            fontSize: 14,
            margin: [0, 10, 0, 10]
          },
          {
            text: `Выбранный год: ${selectedYear === null? 'Все года' : selectedYear}`,
            fontSize: 14,
            margin: [0, 10, 0, 10]
          },
          {
            text: 'Количество заявок',
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 10]
          },
          {
            table: {
              headerRows: 1,
              body: [
                [
                  { text: 'Количество заявок', style: 'tableHeader' },
                  { text: closedRequests.length, style: 'tableCell' }
                ]
              ],
              widths: ['*', 'auto']
            }
          },
          {
            text: 'Статистика по инженерам',
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 10]
          },
          {
            table: {
              headerRows: 1,
              body: engineersStats.map((stat) => [
                { text: `Инженер ${stat.engineer}`, style: 'tableHeader' },
                { text: stat.count, style: 'tableCell' }
              ]),
              widths: ['*', 'auto']
            }
          },
          {
            text: 'Статистика по диспетчерам',
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 10]
          },
          {
            table: {
              headerRows: 1,
              body: dispatchersStats.map((stat) => [
                { text: `Диспетчер ${dispatchersNames[stat.dispatcher] || stat.dispatcher}`, style: 'tableHeader' },
                { text: stat.count, style: 'tableCell' }
              ]),
              widths: ['*', 'auto']
            }
          }
        ],
        styles: {
          tableHeader: {
            fontSize: 12,
            bold: true,
            fillColor: '#f0f0f0'
          },
          tableCell: {
            fontSize: 12
          }
        }
      };
      pdfMake.createPdf(docDefinition).download(fileName);
    };

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e) => {
    const searchQuery = e.target.value.toLowerCase();
    setSearchQuery(searchQuery);
  };

    const [dispatchersNames, setDispatchersNames] = useState({});
    const getDispatchersNames = (requests) => {
      const dispatchersNames = {};
      requests.forEach((request) => {
        if (dispatchersNames[request.dispatcher]) {
          return;
        }
        const dispatcherRef = ref(db, `users/${request.dispatcherID}`);
        onValue(dispatcherRef, (snapshot) => {
          if (snapshot.exists()) {
            const dispatcherData = snapshot.val();
            dispatchersNames[request.dispatcher] = dispatcherData.displayName;
          } else {
            dispatchersNames[request.dispatcher] = `${request.dispatcher} (Удален)`;
      }
          setDispatchersNames(dispatchersNames);
        });
      });
    };

    const getDispatchersStats = (requests) => {
      const groupedByDispatcher = groupBy(requests, 'dispatcher');
      const dispatchersStats = mapValues(groupedByDispatcher, (requests) => {
        return {
          dispatcher: requests[0].dispatcher,
          count: requests.length,
        };
      });
      return Object.values(dispatchersStats);
    };

    return (
      <div className="table__opened">
        <h1>Завершенные заявки</h1>
        <div className="items-table__search-subtitle">
          <input
            className="field-input"
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Название или адрес"
          />
        </div>
        <div className="items-table__search items-table__search-title">
            <select className="field-input" id="month" value={selectedMonth} onChange={handleMonthChange}>
              <option value={null}>Все месяца</option>
              <option value="1">Январь</option>
              <option value="2">Февраль</option>
              <option value="3">Март</option>
              <option value="4">Апрель</option>
              <option value="5">Май</option>
              <option value="6">Июнь</option>
              <option value="7">Июль</option>
              <option value="8">Август</option>
              <option value="9">Сентябрь</option>
              <option value="10">Октябрь</option>
              <option value="11">Ноябрь</option>
              <option value="12">Декабрь</option>
            </select>
            <select className="field-input" id="year" value={selectedYear} onChange={handleYearChange}>
              <option value={null}>Все года</option>
              {Array.from(Array(5), (_, i) => (
                <option key={i} value={new Date().getFullYear() - i}>
                  {new Date().getFullYear() - i}
                </option>
                ))}
            </select>
            {role === 'Директор' && (
              <button className="btn" onClick={handleShowStatsModal}>Статистика</button>
            )}
            </div>
            {showStatsModal && (
            <div className="modal">
              <div className="modal-content">
                <div className="form-dw">
                  <div className="modal__item">
                    <h3>Статистика</h3>
                    <p>Количество заявок: {closedRequests.length}</p>
                    <p>Количество заявок за выбранный месяц: {closedRequests.filter((request) => {
                      const requestDate = new Date(request.date);
                      const requestMonth = requestDate.getMonth() + 1;
                      return requestMonth === selectedMonth;
                    }).length}</p>
                    <p>Количество заявок за выбранный год: {closedRequests.filter((request) => {
                      const requestDate = new Date(request.date);
                      const requestYear = requestDate.getFullYear();
                      return requestYear === selectedYear;
                    }).length}</p>
                  </div>
                  {closedRequests.length > 0 && (
                    <div>
                      <div className="modal__item">
                        <h3>Статистика по инженерам:</h3>
                        <ul>
                          {engineersStats.map(({ engineer, count }) => (
                            <li key={engineer}>
                              {engineer}: {count}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="modal__item">
                        <h3>Статистика по диспетчерам:</h3>
                        <ul>
                          {dispatchersStats.map(({ dispatcher, count }) => (
                            <li key={dispatcher}>
                              {dispatchersNames[dispatcher] || dispatcher}: {count}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                  <div className="flex justify">
                    <button className="btn-stat" onClick={() => setShowStatsModal(false)}>Закрыть</button>
                    <button className="btn-item_stat" onClick={handleDownloadPdf}>Скачать в PDF</button>
                  </div>
                </div>
              </div>
            )}
            <div className="items-table__opened media-opened">
              <span>Объект</span>
              <span>Проблема</span>
              <span>Ремонт</span>
              <span>Создана</span>
            </div>
            {loading? (
              <LoadingIndicator />
            ) : closedRequests.length === 0? (
              <EmptyRequestsMessage />
            ) : (
              closedRequests
              .filter((request) => {
                  const nameObjectMatch = request.nameObject.toLowerCase().includes(searchQuery);
                  const addressMatch = request.address.toLowerCase().includes(searchQuery);
                  return nameObjectMatch || addressMatch;
                })
              .map((request) => (
                  <ClosedRequestRow key={request.id} request={request} handleCloseForm={handleCloseForm} />
                ))
            )}
        </div>
    );
}